import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchDefaultMembershipTermsOfUse,
  fetchMembershipTermsOfUse,
  fetchUserMembershipTermsOfUse,
  fetchUserMembershipTermsOfUseAcceptance,
} from '../api/membershipTermsOfUse.api';

export const membershipTermsOfUseQueryKeys = createQueryKeys(
  'membershipTermsOfUse',
  {
    fetchDefault: ({ organizationId }: { organizationId: string }) => ({
      queryFn: () => fetchDefaultMembershipTermsOfUse({ organizationId }),
      queryKey: [organizationId],
    }),
    fetchForMembership: ({
      organizationId,
      membershipId,
    }: {
      organizationId: string;
      membershipId: string;
    }) => ({
      queryFn: () =>
        fetchMembershipTermsOfUse({ organizationId, membershipId }),
      queryKey: [organizationId, membershipId],
    }),
    fetchForUserMembership: ({
      organizationId,
      clientId,
      userMembershipId,
    }: {
      organizationId: string;
      clientId: string;
      userMembershipId: string;
    }) => ({
      queryFn: () =>
        fetchUserMembershipTermsOfUse({
          organizationId,
          clientId,
          userMembershipId,
        }),
      queryKey: [organizationId, clientId, userMembershipId],
    }),
    fetchAcceptanceForUserMembership: ({
      organizationId,
      clientId,
      userMembershipId,
    }: {
      organizationId: string;
      clientId: string;
      userMembershipId: string;
    }) => ({
      queryFn: () =>
        fetchUserMembershipTermsOfUseAcceptance({
          organizationId,
          clientId,
          userMembershipId,
        }),
      queryKey: [organizationId, clientId, userMembershipId, 'acceptance'],
    }),
  },
);
